import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getCommonData } from '../components/Main/actions';
import { deleteReservation } from '../components/DeleteReservationContent/actions'; 
import Header from '../components/Header/Header';
import DeleteReservationContent from '../components/DeleteReservationContent/DeleteReservationContent'; 


class DeleteReservation extends Component {
  constructor(props) {
    super(props);

    this.deleteReservation = this.deleteReservation.bind(this);
  }

  componentDidMount() {
    document.title = 'Zrušení rezervace';

    if (this.props.logo.status === false) {
      this.props.getCommonData();
    }
      
    this.deleteReservation();
  }

  deleteReservation() {
    const { reservationHash, } = this.props.params;

    this.props.deleteReservation(reservationHash);
  }

  render() {
    const { deleteReservationData, logo, } = this.props;

    return (
      <div>

        <Header
          logoName={logo.fileName}
          office={null}
        />   

        <div className="container-fluid page-header">
          <DeleteReservationContent
            deleteReservationData={deleteReservationData}
            deleteReservation={this.deleteReservation}
          />
        </div>

      </div>
     
    );
  }
}


const mapStateToProps = (state) => {
  const { deleteReservation, } = state;
  return { 
    deleteReservationData: deleteReservation,
    logo: {
      status: state.main.status, 
      ...state.main.data.logo,
    }
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCommonData: bindActionCreators(getCommonData, dispatch),
    deleteReservation: bindActionCreators(deleteReservation, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteReservation);


// WEBPACK FOOTER //
// ./src/pages/DeleteReservation.js